import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/es/servicios/toxicologia-regulatoria/")({
  head: () => buildRouteHead("/es/servicios/toxicologia-regulatoria"),
  component: ServicePage,
});

